import { IRoute } from "../../../common/helpers/routesMapper";
import { seo } from "../../../common/helpers/seo";

import loadable from "./lazy";

export default {
    component: loadable,
    renderSeo: (store: any, allMessage: {[key: string]: string}, lang: string) => {
        return seo({
            title: allMessage["article.filters.title"],
            description: allMessage["article.filters.description"],
            allMessage,
            lang,
        });
    },
} satisfies IRoute;
